import React, { useEffect, useState } from 'react';
import BaseTable from '@/components/base-table';
import HeadingCenter from '@/components/common/heading-center';
import { customerPage } from '@/components/common/heading-center/breadcrumb-config';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomers } from '@/store/actions/customer';
import MyImage from '@/components/common/image';
import './style.scss';
import { Link } from 'react-router-dom';
import Select from '@/components/common/select';
import Button from '@/components/common/button';
import IconPlus from '@/assets/images/icons/icons-plus2.svg';
import AddCustomer from './create/index';
import { getCustomerAvatar } from '@/utils/file';
import { CUSTOMER_STATUS, CUSTOMER_STATUSES } from '@/constant/customer';
import configs from '../../config';
import { PAGINATION_DEFAULT } from '@/common/constant';

const Customer = () => {
  const dispatch = useDispatch();
  const [isAddCustomer, setIsAddCustomer] = useState(false);
  const { list, isLoading } = useSelector((state) => state.customer);
  const [filter, setFilter] = useState(defaultQuery);

  /**
   * Call API get categories with params
   * @param {*} params
   */
  const getCustomersFunc = (params) => {
    if (params?.search)
      dispatch(
        getCustomers({
          ...params,
          is_active:
            params.is_active === undefined
              ? undefined
              : params.is_active === CUSTOMER_STATUS.active.value,
        }),
      );
  };

  const isShowData = Object.values(filter).filter((_) => _)?.length > 2;

  useEffect(() => {
    if (isShowData) getCustomersFunc(filter);
  }, [filter]);

  const onSearch = (search = '') => {
    setFilter((value) => ({ ...value, search, page: 1 }));
  };
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === 'Disabled User', // Column configuration not to be checked
      name: record.name,
    }),
  };

  const columns = [
    {
      title: '',
      dataIndex: 'img',
      render: (value, record) => {
        return (
          <Link to={`customer/${record.guid}`} className="align-center">
            <MyImage
              src={getCustomerAvatar(record.files)}
              className="item-avatar"
              alt="user avatar"
            />
          </Link>
        );
      },
    },
    {
      title: 'First name',
      dataIndex: 'first_name',
      render: (value, record) => {
        return (
          <Link to={`customer/${record.guid}`} className="align-center">
            {value || ''}
          </Link>
        );
      },
    },
    {
      title: 'Last name',
      dataIndex: 'last_name',
      render: (value, record) => {
        return (
          <Link to={`customer/${record.guid}`} className="align-center">
            {value || ''}
          </Link>
        );
      },
    },
    { title: 'Email', dataIndex: 'email_address', align: 'left' },
    {
      title: 'Status',
      dataIndex: 'is_offline',
      align: 'center',
      render: (value) => (value ? 'offline' : 'online'),
    },
  ];
  return (
    <div className="customer">
      <HeadingCenter pageConfig={customerPage} isSearch>
        {configs.ssoManagementOnly === 'false' && (
          <>
            <Button className="btn-action" icon={IconPlus} onClick={() => setIsAddCustomer(true)}>
              Add customer
            </Button>
          </>
        )}
      </HeadingCenter>
      <BaseTable
        isExpandProp={false}
        onSearch={onSearch}
        filter={
          <Select
            className="filter-option"
            placeholder="Filter by"
            options={CUSTOMER_STATUSES}
            value={filter.is_active}
            onChange={(v) => setFilter((f) => ({ ...f, is_active: v }))}
          />
        }
        rowKey="guid"
        columns={columns}
        data={isShowData ? (!isLoading && list?.data) || [] : null}
        isLoading={isLoading}
        onChangePageProps={(p) => setFilter((v) => ({ ...v, ...p }))}
        total={list?.metadata?.total}
        metadata={filter}
        rowSelection={{ type: 'checkbox', ...rowSelection }}
      />
      <AddCustomer isOpen={isAddCustomer} onCloseProp={() => setIsAddCustomer(false)} />
    </div>
  );
};

export default Customer;

const defaultQuery = { ...PAGINATION_DEFAULT };
